import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { IDialog } from '../../interfaces/common.interface';

@Component({
    selector: 'app-confirmation',
    imports: [],
    templateUrl: './confirmation.component.html',
    styleUrl: './confirmation.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationComponent {
  config!: IDialog;
  private onCloseEvent: Subject<boolean> = new Subject(); // Observable to send data back
  onClose: Observable<boolean> = this.onCloseEvent.asObservable();
  private readonly modalRef = inject(BsModalRef);

  constructor() {}

  confirm(): void {
    this.onCloseEvent.next(true);
    this.modalRef?.hide();
  }

  decline(): void {
    this.onCloseEvent.next(false);
    this.modalRef?.hide();
  }
}
